<mat-dialog-content class="advisories">
	<epi-heading
		level="2"
		appear-as="1"
		color="primary"
	>
		State Fraud Advisories
	</epi-heading>
	<button class="o-modal-dismiss">
		<epi-icon
			mat-dialog-close
			use="close"
			size="24"
		></epi-icon>
	</button>
	<table>
		<thead>
			<tr>
				<th>State</th>
				<th>Language Required</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>AK</td>
				<td>
					A statement that states in substance the following: "A person who knowingly and with intent to
					injure, defraud, or
					deceive an insurance company files a claim containing false, incomplete, or misleading information
					may be
					prosecuted under state law."
					<br />
					<br />
					A lack of the statement on a claim form does not constitute a defense to prosecution under the
					Insurance Code.
				</td>
			</tr>
			<tr>
				<td>AL</td>
				<td>
					The following statement or a substantially similar statement: "Any person who knowingly presents a
					false or
					fraudulent claim for payment of a loss or benefit or who knowingly presents false information in an
					application
					for insurance is guilty of a crime and may be subject to restitution, fines, or confinement in
					prison, or any
					combination thereof."
					<br />
					A lack of the fraud statement does not constitute a defense in any prosecution for insurance fraud.
				</td>
			</tr>
			<tr>
				<td>AR</td>
				<td>Use Multi-State fraud language</td>
			</tr>
			<tr>
				<td>AZ</td>
				<td> Must include in substance the following statement: "For your protection Arizona law requires the
					following
					statement to appear on this form. Any person who knowingly presents a false or fraudulent claim for
					payment of a
					loss is subject to criminal and civil penalties."
				</td>
			</tr>
			<tr>
				<td>CA</td>
				<td>General: "Any person who knowingly presents false or fraudulent information to obtain or amend
					insurance
					coverage or to make a claim for the payment of a loss is guilty of a crime and may be subject to
					fines and
					confinement in state prison." This statement must be preceded by the words: "For your protection
					California law
					requires the following to appear on this form" or other explanatory words of similar meaning.
				</td>
			</tr>
			<tr>
				<td>CO</td>
				<td>A statement substantially the same as the following: "It is unlawful to knowingly provide false,
					incomplete, or
					misleading facts or information to an insurance company for the purpose of defrauding or attempting
					to defraud
					the company. Penalties may include imprisonment, fines, denial of insurance and civil damages. Any
					insurance
					company or agent of an insurance company who knowingly provides false, incomplete, or misleading
					facts or
					information to a policyholder or claimant for the purpose of defrauding or attempting to defraud the
					policyholder
					or claimant with regard to a settlement or award payable for insurance proceeds shall be reported to
					the Colorado
					Division of Insurance within the Department of Regulatory Agencies."
				</td>
			</tr>
			<tr>
				<td>CT</td>
				<td>Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>DC</td>
				<td>Verbatim: "WARNING: It is a crime to provide false or misleading information to an insurer for the
					purpose of
					defrauding the insurer or any other person. Penalties include imprisonment and/or fines. In
					addition, an insurer
					may deny insurance benefits if false information materially related to a claim was provided by the
					applicant." [DC
					Code] OR "Any person who knowingly presents a false or fraudulent claim for payment of a loss or
					benefit or knowingly
					presents false information in an application for insurance is guilty of a crime and may be subject
					to fines and
					confinement in prison." [NAIC Model]
				</td>
			</tr>
			<tr>
				<td>
					DE
				</td>
				<td>General: A statement that clearly states in substance the following: "Any person who knowingly, and
					with intent
					to injure, defraud or deceive any insurer, files a statement of claim containing any false,
					incomplete or misleading
					information is guilty of a felony." The lack of such a statement does not constitute a defense
					against prosecution
					for insurance fraud.
				</td>
			</tr>
			<tr>
				<td>
					FL
				</td>
				<td>
					General: A statement which clearly states in substance the following: "Any person who knowingly and
					with intent
					to injure, defraud, or deceive any insurer files a statement of claim containing any false,
					incomplete, or misleading
					information is guilty of a felony of the third degree." Statement must be approved by Office of
					Insurance
					Regulation of the Financial Services Commission.
				</td>
			</tr>
			<tr>
				<td>
					GA
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					HI
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					IA
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					ID
				</td>
				<td>
					A statement that clearly states in substance the following: "Any person who knowingly, and with
					intent to defraud
					or deceive any insurance company, files a statement containing any false, incomplete or misleading
					information is
					guilty of a felony."
				</td>
			</tr>
			<tr>
				<td>
					IL
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					IN
				</td>
				<td>
					A statement that clearly states in substance the following: "A person who knowingly and with intent
					to defraud an
					insurer files a statement of claim containing any false, incomplete, or misleading information
					commits a felony."
				</td>
			</tr>
			<tr>
				<td>
					KS
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					KY
				</td>
				<td>
					Applications: A statement in a form approved by the Department of Insurance that clearly states in
					substance the
					following: "Any person who knowingly and with intent to defraud any insurance company or other
					person files an
					application for insurance containing any materially false information or conceals, for the purpose
					of misleading,
					information concerning any fact material thereto commits a fraudulent insurance act, which is a
					crime."
					Claim Forms: A statement in a form approved by the Department of Insurance that clearly states in
					substance the
					following: "Any person who knowingly and with intent to defraud any insurance company or other
					person files a
					statement of claim containing any materially false information or conceals, for the purpose of
					misleading,
					information concerning any fact material thereto commits a fraudulent insurance act, which is a
					crime."
				</td>
			</tr>
			<tr>
				<td>
					LA
				</td>
				<td>
					General: A statement that clearly states in substance the following: "Any person who knowingly
					presents a false
					or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an
					application for
					insurance is guilty of a crime and may be subject to fines and confinement in prison."
				</td>
			</tr>
			<tr>
				<td>
					MA
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					MD
				</td>
				<td>
					The following statement or a substantially similar statement: "Any person who knowingly or willfully
					presents a
					false or fraudulent claim for payment of a loss or benefit or who knowingly or willfully presents
					false information
					in an application for insurance is guilty of a crime and may be subject to fines and confinement in
					prison."
				</td>
			</tr>
			<tr>
				<td>
					ME
				</td>
				<td>
					The following statement or a substantially similar statement: "It is a crime to knowingly provide
					false, incomplete
					or misleading information to an insurance company for the purpose of defrauding the company.
					Penalties may
					include imprisonment, fines or denial of insurance benefits."
				</td>
			</tr>
			<tr>
				<td>
					MI
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					MN
				</td>
				<td>
					General: A warning substantially as follows: "A person who files a claim with intent to defraud or
					helps commit a
					fraud against an insurer is guilty of a crime." The absence of the required warning does not
					constitute a defense in
					a prosecution for a violation of chapter 609 or any other chapter of Minnesota Statutes.
				</td>
			</tr>
			<tr>
				<td>
					MO
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					MS
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					MT
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					NC
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					ND
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					NE
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					NH
				</td>
				<td>
					A statement that clearly states in substance the following: "Any person who, with a purpose to
					injure, defraud or
					deceive any insurance company, files a statement of claim containing any false, incomplete or
					misleading
					information is subject to prosecution and punishment for insurance fraud as provided in RSA 638:20."
				</td>
			</tr>
			<tr>
				<td>
					NJ
				</td>
				<td>
					Claim Forms: A statement in a form approved by the Commissioner of Banking and Insurance that
					clearly states in
					substance the following: "Any person who knowingly files a statement of claim containing any false
					or misleading
					information is subject to criminal and civil penalties."
					Application Forms: "Any person who includes any false or misleading information on an application
					for an
					insurance policy is subject to criminal and civil penalties." In lieu of the statement, insurers may
					use a
					substantially similar statement with the prior approval of the Commissioner of Banking and
					Insurance.
				</td>
			</tr>
			<tr>
				<td>
					NM
				</td>
				<td>
					A statement which states substantially as follows: "Any person who knowingly presents a false or
					fraudulent
					claim for payment of a loss or benefit or knowingly presents false information in an application for
					insurance is
					guilty of a crime and may be subject to civil fines and criminal penalties."
				</td>
			</tr>
			<tr>
				<td>
					NV
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					NY
				</td>
				<td>
					General: Except for automobile insurance, all claim forms for insurance, and all applications shall
					contain the
					following statement: "Any person who knowingly and with intent to defraud any insurance company or
					other
					person files an application for insurance or statement of claim containing any materially false
					information, or
					conceals for the purpose of misleading, information concerning any fact material thereto, commits a
					fraudulent
					insurance act, which is a crime, and shall also be subject to a civil penalty not to exceed five
					thousand dollars and
					the stated value of the claim for each such violation." Insurers may use substantially similar
					warning statements
					provided such warning statements are submitted to the Criminal Investigations Unit for prior
					approval. [11 NY
					ADC 86.4(a)]
				</td>
			</tr>
			<tr>
				<td>
					OH
				</td>
				<td>
					A warning substantially as follows: "Any person who, with intent to defraud or knowing that he is
					facilitating a
					fraud against an insurer, submits an application or files a claim containing a false or deceptive
					statement is guilty
					of insurance fraud." The absence of such a warning does not constitute a defense in a prosecution
					for insurance
					fraud or a violation of any other section of the Revised Code. While the Department of Insurance
					(DOI) has not
					prescribed any particular language to be used, the language should be substantially similar to that
					contained in
					the statute. Insurers intending to use language other than the exact language contained in the
					statute must give
					DOI prior written notice of the language to be used.
				</td>
			</tr>
			<tr>
				<td>
					OK
				</td>
				<td>
					General: A statement that clearly indicates in substance the following: "WARNING: Any person who
					knowingly,
					and with intent to injure, defraud or deceive any insurer, makes any claim for the proceeds of an
					insurance policy
					containing any false, incomplete or misleading information is guilty of a felony."
				</td>
			</tr>
			<tr>
				<td>
					OR
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					PA
				</td>
				<td>
					General: "Any person who knowingly and with intent to defraud any insurance company or other person
					files an
					application for insurance or statement of claim containing any materially false information or
					conceals for the
					purpose of misleading, information concerning any fact material thereto commits a fraudulent
					insurance act,
					which is a crime and subjects such person to criminal and civil penalties."
				</td>
			</tr>
			<tr>
				<td>
					RI
				</td>
				<td>
					General: The following statement or a substantially similar statement: "Any person who knowingly
					presents a
					false or fraudulent claim for payment of a loss or benefit or knowingly presents false information
					in an application
					for insurance is guilty of a crime and may be subject to fines and confinement in prison." The lack
					of such a
					statement does not constitute a defense in any prosecution for a fraudulent insurance act.
				</td>
			</tr>
			<tr>
				<td>
					SC
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					SD
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					TN
				</td>
				<td>
					General: A statement that clearly states in substance the following, or words to that effect: "It is
					a crime to
					knowingly provide false, incomplete or misleading information to an insurance company for the
					purpose of
					defrauding the company. Penalties include imprisonment, fines and denial of insurance benefits." The
					lack of such
					a statement does not constitute a defense in any criminal prosecution under s 56-53-102 nor in any
					civil action
					under s 56-53-102 or s 56-53-103.
				</td>
			</tr>
			<tr>
				<td>
					TX
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					UT
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					VA
				</td>
				<td>
					A statement that clearly states in substance the following: "It is a crime to knowingly provide
					false, incomplete or
					misleading information to an insurance company for the purpose of defrauding the company. Penalties
					include
					imprisonment, fines and denial of insurance benefits."
				</td>
			</tr>
			<tr>
				<td>
					VT
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					WA
				</td>
				<td>
					A statement that clearly states in substance the following: "It is a crime to knowingly provide
					false, incomplete or
					misleading information to an insurance company for the purpose of defrauding the company. Penalties
					include
					imprisonment, fines and denial of insurance benefits." The lack of a statement required in this
					section does not
					constitute a defense in any criminal prosecution nor any civil action.
				</td>
			</tr>
			<tr>
				<td>
					WI
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					WV
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					WY
				</td>
				<td>
					Use Multi-State fraud language
				</td>
			</tr>
			<tr>
				<td>
					MULTI-STATE
				</td>
				<td>
					"Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or
					knowingly
					presents false information in an application for insurance is guilty of a crime and may be subject
					to fines and
					confinement in prison."
				</td>
			</tr>
		</tbody>
	</table>
</mat-dialog-content>
